
import api from '.';

const tagType = 'transaction';

const transactionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    startStopTransaction: builder.mutation({
      query: (params) => ({
        url: '/ocpp/command',
        method: 'POST',
        body: params
      })
    })
  })
});
export default transactionsApi;
export const { useStartStopTransactionMutation } = transactionsApi;
